import { AnyAction } from "redux";
import { Dispatch } from "react";
import { Query, Result } from "../../../../interfaces";
import { Find } from "../../../commons";
import { Adapter } from "../../../../shared/adapter";
import { CommonsCapacitiesAdapter } from "../../../../adapter/commonsCapacities-adapter";

export const FETCH_DATA_COMMONS_CAPACITIES_REQUEST = 'FETCH_DATA_COMMONS_CAPACITIES_REQUEST';
export const FETCH_DATA_COMMONS_CAPACITIES_SUCCESS = 'FETCH_DATA_COMMONS_CAPACITIES_SUCCESS';
export const FETCH_DATA_COMMONS_CAPACITIES_FAILURE = 'FETCH_DATA_COMMONS_CAPACITIES_FAILURE';

interface ActionPagination<T> {
    type: string,
    payload: T
}

const fetchDataCommonsCapacitiesRequest = () => {
    return {
        type: FETCH_DATA_COMMONS_CAPACITIES_REQUEST,
    };
};

const fetchDataCommonsCapacitiesSuccess = (data: any): ActionPagination<Result<any>> => {
    return {
        type: FETCH_DATA_COMMONS_CAPACITIES_SUCCESS,
        payload: data
    };
};

const fetchDataCommonsCapacitiesFailure = (error: any) => {
    return {
        type: FETCH_DATA_COMMONS_CAPACITIES_FAILURE,
        payload: error,
    };
};

export const find = (page: number, pageSize: number, query:Query) => {
    return async (dispatch: Dispatch<AnyAction>) => {
        dispatch(fetchDataCommonsCapacitiesRequest());
        try {
            const response = await Find('commons_capacities', query, page, pageSize);
            dispatch(fetchDataCommonsCapacitiesSuccess(
                { 
                    meta : response.meta,
                    values : Adapter.from(response.data).to((value) => new CommonsCapacitiesAdapter(value).adapt()) 
                }
            ));

        } catch (error: any) {
            dispatch(fetchDataCommonsCapacitiesFailure(error.message));
        }
    };
};
